import React, { useState, useCallback, useEffect } from 'react'

// Module-scoped state so any consumer of useToast() pushes into the same store
// that <ToastContainer /> renders. Layout mounts the one container, so a
// toast shows on every page under it. Do not mount another.
const listeners = new Set()
let nextId = 1
let store = []

function emit() {
  for (const l of listeners) l(store)
}

function push(kind, message) {
  const id = nextId++
  store = [...store, { id, kind, message }]
  emit()
  setTimeout(() => {
    store = store.filter(t => t.id !== id)
    emit()
  }, 3000)
}

export function useToast() {
  const toast = {
    success: useCallback((m) => push('success', m), []),
    error: useCallback((m) => push('error', m), [])
  }
  return { toast }
}

export function ToastContainer() {
  const [items, setItems] = useState(store)
  useEffect(() => {
    listeners.add(setItems)
    return () => listeners.delete(setItems)
  }, [])

  if (items.length === 0) return null

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 'calc(16px + env(safe-area-inset-bottom))',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        pointerEvents: 'none'
      }}
    >
      {items.map(t => (
        <div
          key={t.id}
          className={`toast toast--${t.kind}`}
          style={{
            padding: '12px 20px',
            borderRadius: 8,
            color: 'white',
            fontWeight: 500,
            background: t.kind === 'error' ? '#dc2626' : '#16a34a',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            pointerEvents: 'auto',
            maxWidth: '90vw',
            wordWrap: 'break-word'
          }}
        >
          {t.message}
        </div>
      ))}
    </div>
  )
}
